export default {
    'bond-no': 'Bond No.',
    'entry-no': 'Entry No.',
    'debit': 'Debit',
    'credit': 'Credit',
    'currency-debit': 'Foreign currency debit',
    'currency-credit': 'Foreign currency credit',
    'currency-price': 'Price',
    'balance': 'Balance',
    'currency': 'Currency',
    'date': 'Date',
    'paper-document-no': 'Ref. Doc.',
    'note': 'Description',
    'matching-date': 'Conciliation date',
}